var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncEditsCanva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 47,
    viewBox: "0 0 200 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 199.311,
    height: 46.524,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198.311,
    height: 45.524,
    rx: 9.5,
    stroke: "#35475A",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "#7D2AE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint0_radial_1_43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint1_radial_1_43)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint2_radial_1_43)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint3_radial_1_43)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint4_radial_1_43)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4088 26.1368C29.3008 26.1368 29.2068 26.2278 29.1078 26.4258C27.9968 28.6798 26.0766 30.2748 23.855 30.2748C21.2862 30.2748 19.6955 27.9558 19.6955 24.7518C19.6955 19.3258 22.719 16.1878 25.3746 16.1878C26.6155 16.1878 27.3733 16.9678 27.3733 18.2088C27.3733 19.6818 26.5365 20.4618 26.5365 20.9808C26.5365 21.2148 26.6816 21.3558 26.9692 21.3558C28.1248 21.3558 29.4808 20.0278 29.4808 18.1518C29.4808 16.3328 27.8978 14.9968 25.2424 14.9968C20.8536 14.9968 16.9531 19.0648 16.9531 24.6948C16.9531 29.0528 19.4416 31.9328 23.2812 31.9328C27.3565 31.9328 29.7128 27.8778 29.7128 26.5618C29.7128 26.2708 29.5638 26.1368 29.4088 26.1368Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.673 28.658C48.823 28.658 47.113 27.214 46.524 25.276L48.5 24.345C48.804 25.77 49.849 26.872 51.73 26.872C53.307 26.872 54.428 26.15 54.428 24.839C54.428 23.376 53.06 22.92 51.236 22.369C49.127 21.723 46.866 20.887 46.866 18.303C46.866 15.947 48.728 14.465 51.388 14.465C53.934 14.465 55.53 15.814 56.024 17.448L54.2 18.322C53.839 17.068 52.889 16.232 51.369 16.232C50.02 16.232 48.975 16.897 48.975 18.132C48.975 19.652 50.533 20.032 52.281 20.583C54.599 21.324 56.537 22.293 56.537 24.763C56.537 27.176 54.58 28.658 51.673 28.658Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6032 32.059C58.2422 32.059 57.9762 32.04 57.6342 31.945L57.7862 30.292C58.1472 30.368 58.5652 30.406 58.8312 30.406C60.1992 30.406 60.5602 29.323 60.7882 28.392L57.4062 19.253H59.4392L61.7382 26.359L64.1512 19.253H66.1272L62.5742 28.696C61.5862 31.337 60.3702 32.059 58.6032 32.059Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6468 28.354V19.253H69.5658V20.64H69.5848C70.0978 19.481 71.2188 18.968 72.4348 18.968C74.0118 18.968 75.4938 19.861 75.4938 22.027V28.354H73.5748V22.426C73.5748 21.324 72.9858 20.602 71.9028 20.602C70.6298 20.602 69.5658 21.59 69.5658 23.509V28.354H67.6468Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6952 28.639C79.2252 28.639 77.1542 27.062 77.1542 23.813C77.1542 20.507 79.3392 18.949 81.7332 18.949C83.6142 18.949 85.0582 19.956 85.6282 21.78L83.8042 22.388C83.4812 21.153 82.7782 20.564 81.6762 20.564C80.3842 20.564 79.1302 21.495 79.1302 23.813C79.1302 26.169 80.4792 27.024 81.7522 27.024C82.6642 27.024 83.6142 26.511 83.8612 25.105L85.7992 25.219C85.4382 27.328 83.9562 28.639 81.6952 28.639Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1635 28.354V14.769H102.188V16.593H95.1585V20.526H101.371V22.293H95.1585V26.53H102.169V28.354H93.1635Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.696 28.62C105.891 28.62 103.687 27.252 103.687 23.756C103.687 20.431 105.701 18.968 107.601 18.968C109.102 18.968 110.033 19.861 110.508 20.583H110.527V14.769H112.446V28.354H110.527V27.024H110.508C110.09 27.727 109.159 28.62 107.696 28.62ZM108.076 27.043C109.558 27.043 110.565 25.694 110.565 23.68C110.565 21.666 109.558 20.583 108.057 20.583C106.651 20.583 105.625 21.552 105.625 23.68C105.625 25.865 106.689 27.043 108.076 27.043Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.683 28.354V19.253H116.602V28.354H114.683ZM115.652 17.657C114.873 17.657 114.322 17.125 114.322 16.422C114.322 15.719 114.873 15.168 115.652 15.168C116.412 15.168 116.963 15.719 116.963 16.422C116.963 17.125 116.412 17.657 115.652 17.657Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.375 28.601C120.722 28.601 119.905 27.651 119.905 26.492V20.811H118.157V19.253H119.354C119.791 19.253 119.962 19.082 119.962 18.645V16.802L121.824 16.384V19.253H124.009V20.811H121.824V26.112C121.824 26.663 122.071 26.986 122.736 26.986C122.983 26.986 123.363 26.929 123.705 26.758L124.104 28.221C123.61 28.449 123.059 28.601 122.375 28.601Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.198 28.639C126.994 28.639 125.531 27.632 125.227 25.96L126.994 25.447C127.241 26.492 128.058 27.138 129.293 27.138C130.376 27.138 130.984 26.682 130.984 25.903C130.984 25.181 130.528 24.82 128.761 24.459C126.557 24.003 125.531 23.091 125.531 21.685C125.531 20.013 126.899 18.949 129.027 18.949C130.889 18.949 132.314 19.804 132.903 21.229L131.193 21.894C130.832 21.02 130.034 20.431 128.951 20.431C128.001 20.431 127.431 20.868 127.431 21.533C127.431 22.198 127.925 22.578 129.73 22.958C131.896 23.414 132.903 24.269 132.903 25.77C132.903 27.537 131.497 28.639 129.198 28.639Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.032 28.658C142.688 28.658 139.705 26.378 139.705 21.533C139.705 16.726 142.688 14.465 145.956 14.465C148.92 14.465 150.801 16.327 151.504 18.968L149.452 19.595C148.939 17.505 147.723 16.27 145.861 16.27C143.638 16.27 141.795 18.018 141.795 21.533C141.795 25.048 143.657 26.853 146.032 26.853C147.875 26.853 149.072 25.713 149.395 23.851L151.447 24.25C150.915 26.796 149.129 28.658 146.032 28.658Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.183 28.62C154.321 28.62 153.105 27.575 153.105 25.979C153.105 24.402 154.359 23.319 156.905 22.901L158.387 22.654C159.166 22.521 159.356 22.35 159.356 21.913C159.356 21.096 158.615 20.507 157.475 20.507C156.335 20.507 155.461 21.096 155.119 22.103L153.561 21.229C154.112 19.804 155.575 18.949 157.532 18.949C159.926 18.949 161.256 20.222 161.199 22.369L161.085 26.226C161.066 26.834 161.332 27.119 161.883 27.062V28.544C161.693 28.582 161.465 28.601 161.237 28.601C159.869 28.601 159.394 27.898 159.356 26.454H159.337C158.9 27.841 157.76 28.62 156.183 28.62ZM156.468 27.062C158.007 27.062 159.299 25.827 159.337 24.364L159.356 23.471C159.147 23.756 158.824 23.889 158.235 24.022L157.152 24.25C155.594 24.573 155.024 25.029 155.024 25.846C155.024 26.606 155.518 27.062 156.468 27.062Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.63 28.354V19.253H165.549V20.64H165.568C166.081 19.481 167.202 18.968 168.418 18.968C169.995 18.968 171.477 19.861 171.477 22.027V28.354H169.558V22.426C169.558 21.324 168.969 20.602 167.886 20.602C166.613 20.602 165.549 21.59 165.549 23.509V28.354H163.63Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.237 28.354L172.76 19.253H174.793L177.282 26.378L179.714 19.253H181.709L178.232 28.354H176.237Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185.611 28.62C183.749 28.62 182.533 27.575 182.533 25.979C182.533 24.402 183.787 23.319 186.333 22.901L187.815 22.654C188.594 22.521 188.784 22.35 188.784 21.913C188.784 21.096 188.043 20.507 186.903 20.507C185.763 20.507 184.889 21.096 184.547 22.103L182.989 21.229C183.54 19.804 185.003 18.949 186.96 18.949C189.354 18.949 190.684 20.222 190.627 22.369L190.513 26.226C190.494 26.834 190.76 27.119 191.311 27.062V28.544C191.121 28.582 190.893 28.601 190.665 28.601C189.297 28.601 188.822 27.898 188.784 26.454H188.765C188.328 27.841 187.188 28.62 185.611 28.62ZM185.896 27.062C187.435 27.062 188.727 25.827 188.765 24.364L188.784 23.471C188.575 23.756 188.252 23.889 187.663 24.022L186.58 24.25C185.022 24.573 184.452 25.029 184.452 25.846C184.452 26.606 184.946 27.062 185.896 27.062Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8958 35.054) rotate(-49.4156) scale(23.6075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0807 11.47) rotate(54.7035) scale(26.6218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8958 35.054) rotate(-45.1954) scale(23.3217 10.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4825 12.113) rotate(66.5198) scale(24.0311 40.2574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.725916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.1327 8.865) rotate(48.8515) scale(25.7307 43.1046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.725916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncEditsCanva);
export default __webpack_public_path__ + "static/media/sync-edits-canva.7d8d2ad1649dbaba740b15812dba96c6.svg";
export { ForwardRef as ReactComponent };